import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import {
    Box,
    Grid
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { DEFAULT_LOCALE, INR_CURRENCY_STYLE } from "../util/constant";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton, GridToolbarQuickFilter
} from '@mui/x-data-grid';

const AllUsersHoldings = ({ user }) => {
    const history = useHistory();
    const [rows, setRows] = useState([{ symbol: "" }]);
    const [selectedUser] = useState("")

    const getClassName = (params, field) => {
        return params.field === field && params.value > 0 ? 'profit' : 'loss';
    }

    useEffect(() => {
        const endpoint = '/algo-trading/api/admin/demat/holdings/all-users';
        fetch(endpoint, {
            headers: new Headers({
                'Authorization': user.credential
            }),
        }
        ).then(r => {
            if (r.status >= 400) {
                history.push('/')
                return
            }
            r.text()
                .then(value => {
                    setRows(JSON.parse(value));
                })
        }
        ).catch(error => {
            console.log(error);
            history.push('/')
        });
    }, [selectedUser]);


    const columns = [
        { field: 'userId', headerName: 'User', width: 120 },
        {
            field: 'symbol', headerName: 'Symbol', width: 140, type: 'string',
            renderCell: (params) => (
                <a href={"https://www.tradingview.com/chart/?symbol=NSE:" + params.value} target="_blank">
                    {params.value}
                </a>
            ),
        },
        { field: 'quantity', headerName: 'Quantity', width: 80 },
        {
            field: 'sharePrice', headerName: 'Buy Price', width: 100,
            valueFormatter: ({ value }) => value?.toFixed(2)
        },
        { field: 'ltp', headerName: 'LTP', width: 100, renderCell: ({ value }) => value?.toFixed(2) },
        {
            field: 'profitLoss', headerName: 'Profit/Loss', width: 100, type: 'number',
            renderCell: ({ value }) => value?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)
        },
        {
            field: 'openDays', headerName: 'Open Days', width: 90, type: 'number',
        },
        {
            field: 'percentagePerDay', headerName: 'PPD', width: 80, type: 'number',
            renderCell: ({ value }) => isFinite(value) && !isNaN(value) ? value.toFixed(2) : value
        },
        {
            field: 'percentagePerDayInLast15Days', headerName: 'PPD15', width: 80, type: 'number',
            renderCell: ({ value }) => isFinite(value) && !isNaN(value) ? value.toFixed(2) : value
        },
    ];
    function CustomToolbar() {
        return (
            <GridToolbarContainer title="Data" sx={{ justifyContent: 'flex-start' }}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
                <GridToolbarQuickFilter />
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <Grid item xs={12} md={12}>
                <Grid>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            width: '100%',
                            '& .profit': {
                                color: 'green',
                            },
                            '& .loss': {
                                color: 'red',
                            },
                        }}
                    >
                        <legend><Typography variant="h6">All Users Holdings</Typography></legend>
                        {rows && <DataGrid
                            getRowId={(row) => row?.userId + row?.symbol}
                            rows={rows}
                            columns={columns}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'percentagePerDay', sort: 'asc' }],
                                },
                                pagination: {
                                    paginationModel: {
                                        pageSize: 100
                                    }
                                }
                            }}
                            getCellClassName={(params) => {
                                if (params.field !== 'profitLoss') {
                                    return '';
                                }
                                return getClassName(params, 'profitLoss')
                            }}
                            slots={{
                                toolbar: CustomToolbar
                            }}
                        />}
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default AllUsersHoldings